import React from 'react';
import {
  Container,
  Content,
  Title,
  Subtitle,
  Header,
  HeaderGradient,
  HeaderLogo,
  HeaderTitle,
} from './styles';
import { E_LOGO_WHITE } from '../../constants/images';

const GiftCardClaimed = () => {
  return (
    <Container>
      <Header>
        <HeaderGradient>
          <HeaderLogo src={E_LOGO_WHITE} alt='Eternal Logo' />
          <HeaderTitle>Happy Diwali from all of us at Eternal</HeaderTitle>
        </HeaderGradient>
      </Header>
      <Content>
        <Title>Code has been redeemed</Title>
        <Subtitle>Happy ordering!</Subtitle>
      </Content>
    </Container>
  );
};

export default GiftCardClaimed;
